// extracted by mini-css-extract-plugin
export default {"hygiene":"EndodonticsPage_hygiene__ApBEU"};